var Language;
(function (Language) {
  Language["norwegian"] = "no";
  Language["norwegianBokmal"] = "nb";
  Language["english"] = "en";
  Language["chromeDefault"] = "en-US";
})(Language || (Language = {}));
export const DEFAULT_LANGUAGE = 'NO';
export default Language;